export default {
  me: {},
  match: {},
  passwordReset: {
    email: "",
    confirmationCode: ""
  }
};
